const location_Data = [
  { lat: 49.2827, lng: -123.1207, name: 'Vancouver', timezone: 'America/Vancouver' },
  { lat: 43.6511, lng: -79.3470, name: 'Toronto', timezone: 'America/Toronto' },
  { lat: 49.8951, lng: -97.1384, name: 'Winnipeg', timezone: 'America/Winnipeg' },
  { lat: 28.6139, lng: 77.2090, name: 'New Delhi', timezone: 'Asia/Kolkata' },
  { lat: -25.2744, lng: 133.7751, name: 'Australia', timezone: 'Australia/Sydney' },
  { lat: 51.5074, lng: -0.1278, name: 'London', timezone: 'Europe/London' },
  { lat: 41.8719, lng: 12.5674, name: 'Italy', timezone: 'Europe/Rome' },
  { lat: 51.1657, lng: 10.4515, name: 'Germany', timezone: 'Europe/Berlin' },
  { lat: 36.7783, lng: -119.4179, name: 'California', timezone: 'America/Los_Angeles' }
]
;
  
  export default location_Data;
  